<template>
  <div class="contentbox">
    
    <div class="logo">
      <img :src="logopic ? `/uploads/${logopic}` : '/static/img/logo.png'" alt="" @click="$router.push('/')">
    </div>
    <!-- <div class="chgbox">
      <ul>
        <li>
          <button @click="isSelect=0;seltype='gr'" :class="isSelect==0?'chgbtn active':'chgbtn'" >培训信息查询</button> 
        </li>
        <li>
          <button @click="isSelect=1;seltype='gr'"   :class="isSelect==1?'chgbtn active':'chgbtn'" >测评信息查询</button>  
        </li>
      </ul>
    </div> -->
    <div class="title">
      <a class="light" v-if="isSelect == 0" href="javascript:;">信息查询</a>
      <a class="light" v-else-if="isSelect == 1" href="javascript:;">测评查询</a>
      <a class="light" v-else-if="isSelect == 2" href="javascript:;">课题查询</a>
      <a :href="gourl" class="certexp">证书说明</a>
      <a href="/ExamLogin" class="certexp">测评中心</a>
      <a href="https://www.zhcpw.org.cn/kscx"  class="certexp">查询测评报告</a>           
  </div>
    <div class="inqBox">
      
       <h1><span v-if="isSelect==0">培训信息查询系统</span><span v-else-if="isSelect==1">测评信息查询系统</span><span v-else-if="isSelect==2">课题信息查询</span> </h1>
          <div class="leftBox" v-show="isSelect==0">
            <!-- <p style="margin-top:14px">类别</p> -->
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrCertTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
               <div class="textbox shoujiios"><input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/></div>
                <div class="textbox bianhaoda"><input type="text" v-model="cert.cardid" class="inid" placeholder="请输入证件号码"/></div>
                <div class="textbox da"><input type="text" v-model="cert.code" class="incert" placeholder="请输入证书编号"/></div>             
            </div>
            <div v-show="seltype=='qy'">
              <!-- <p>企业名称</p> -->
              <input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/>
              <!-- <p>统一社会信用代码</p> -->
              <input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/>
              <!-- <p>签发编号</p> -->
              <input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/>
            </div>
            <button @click="submitForm() ">查询</button>
            <!-- <a :href="gourl" class="certexp" style="margin-right:20px"><img src="/static/img/cert.png" alt="" /> 证书说明</a>
            <a href="https://www.cnks.org.cn/kscx"  class="certexp">查询考培证明</a> -->
          </div>
          <div class="leftBox" v-show="isSelect==1">
            <!-- <p style="margin-top:14px">类别</p> -->
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrRongyTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
              <div class="textbox shoujiios"><input type="text" v-model="cert.name" class="inname" placeholder="请输入姓名"/></div>
              <div class="textbox da"><input type="text" v-model="cert.code" class="incert" placeholder="请输入证书编号"/></div>
            </div>
            <div v-show="seltype=='qy'">
              <!-- <p>企业名称</p> -->
              <div class="textbox shoujiios"><input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/></div>
              <!-- <p>统一社会信用代码</p> -->
              <div class="textbox bianhaoda"><input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/></div>
              <!-- <p>签发编号</p> -->
              <div class="textbox da"><input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/></div>
            </div>
            <button @click="submitForm() ">查询</button>
           
          </div>
          <div class="leftBox" v-show="isSelect==2">
            <p style="margin-top:14px">类别</p>
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrKetiTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div>
              <p>课题名称</p>
              <input type="text" v-model="cert.name" class="inname" placeholder="课题名称"/>
              <p>课题编码</p>
              <input type="text" v-model="cert.code" class="incert" placeholder="课题编码"/>
            </div>
            <button @click="submitForm() ">查询</button>
            <!-- <a :href="gourl" class="certexp" style="margin-right:20px"><img src="/static/img/cert.png" alt="" /> 证书说明</a>
            <a href="https://www.cnks.org.cn/kscx"  class="certexp">查询考培证明</a> -->
          </div>
        
    </div>
    <div class="expBox">
              <h2>温馨提示</h2>
              <p v-show="seltype=='gr'">
                1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                2、输入：人名+身份证号+证书编号点击查询；<br/>
                3、输入：人名+证书编号点击查询；<br/>
                4、输入：身份证号+证书编号点击查询；<br/>
                5、证书编码中若有英文字母全部需用大写字母填写；<br/>
                6、身份证号中若有英文字母全部需用大写字母填写。<br/>
              </p>
              <p v-show="seltype=='qy'">
                1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                2、输入：企业名称+统一社会信用代码+签发编号点击查询；<br/>
                3、输入：企业名称+签发编号点击查询；<br/>
                4、输入：统一社会信用代码+签发编号点击查询；<br/>
                5、签发编号中若有英文字母全部需用大写字母填写；<br/>
                6、统一社会信用代码中若有英文字母全部需用大写字母填写。<br/>
              </p>
           
          </div>
    <div class="recodenum">备案号：{{ recodenum }}</div>
    <el-dialog title="请选择测评名称" width="90%" :visible.sync="qyoccupationFlag">
        <el-form >
          <el-form-item label="测评名称">
            <el-select v-model="selcertname" placeholder="请选择测评名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="qyhandleInq()">确 定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="请选择职业名称" width="90%" :visible.sync="occupationFlag">
        <el-form >
          <el-form-item label="职业名称">
            <el-select v-model="selcertname" placeholder="请选择职业名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="handleInq()">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>

import { certificateGR ,certificateQY,getPersonalMember } from '@/request/index';
import { getCertTypes,getFindPage } from '@/request/get';
const rate = window.innerWidth / 375;
export default {
  metaInfo: {
    title: '信息查询',
    meta: [
      {
        name: 'viewport', content:
        `width=device-width, initial-scale=${rate}, maximum-scale=1.0, user-scalable=0,minimal-ui:ios`
      }
    ]
  },
  name: "inquery",
  components: {
  },
  data() {
    return {
      occupations: [],
      occupationFlag:false,
      qyoccupationFlag:false,
      seltype:"gr",
      cert: {
        name: "",
        code:"",
        cardid:"",
        certtypename:""
      },
      selcertname:"",
      gourl:"",
      arrCertTypes:[],
      arrRongyTypes:[],
      arrKetiTypes:[],
      isSelect:0
    }
  },
  created(){
   this.getCertTypes();
   this.getFindPage();
   if(this.$route.query.inqtype=='ry')
   {
    this.isSelect=1;
   }else if(this.$route.query.inqtype=='kt')
   {
    this.isSelect=2;
   }else{
    this.isSelect=0;
   }


  },
  computed: {
     recodenum() {
      return this.$store.getters.recodenum;
    },
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  watch:{
    isSelect(){
      this.cert.certtypename = "";
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    certtypechage(newval) {
      if(newval=="企业测评"){
        this.seltype='qy'
      }else{
        this.seltype='gr'
      }
    },
    async getFindPage() {
      let result = await getFindPage();
      result = result.data || [];
      this.$store.dispatch("SET_PLATES", result)
      let { plates } = this.$store.state;
    let list = plates.filter((item) => '证书说明' == item.name);
    let uuid = list[0].uuid;
    this.gourl = `/news/info/${uuid}/000000`
    },
    goHome() {
      this.$router.push("/");
    },
    handleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择职业名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.name,
          code: this.cert.code,
          certtypename: this.cert.certtypename
        }
      })
    },
    qyhandleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择测评名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.qiyename,
          code: this.cert.code,
          certtypename: this.cert.certtypename,
          type:'qy'
        }
      })
    },
    async getCertTypes(){
      let result = await getCertTypes();
      for(let i=0;i<result.data.length;i++) {
        if(result.data[i].type=='测评')
        {
          this.arrRongyTypes.push(result.data[i])
        }else if(result.data[i].type=='课题')
        {
          this.arrKetiTypes.push(result.data[i])
        }else{
          this.arrCertTypes.push(result.data[i])
        }
      }
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async submitForm() {
      if(!this.cert.certtypename)
      {
        this.$message.error("请选择证书类别");
        return;
      }
      if(this.seltype=='qy')
      {
        if ((this.qiyename == "" && this.code == "")
          || (this.qiyename == "" && this.socialcreditcode == "")
          || (this.code == "" && this.socialcreditcode == "")) {
          return;
        }
        let result =await certificateQY(this.cert.certtypename,this.cert.code,this.cert.qiyename,this.cert.socialcreditcode);
        if(result.data.length==1)
        {
          this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.qiyename,
              code: this.cert.code,
              certtypename: this.cert.certtypename,
              type:'qy'
            }
          })
        }else if(result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }else{
      if ((this.name == "" && this.code == "")
        || (this.name == "" && this.cardid == "")
        || (this.code == "" && this.cardid == "")) {
        return;
      }
        // if(this.cert.certtypename.indexOf("测评")>-1)
        // {
        //   if ((this.cert.name == "" && this.cert.code == "")) {
        //     return;
        //   }
        //   let result =await getPersonalMember(this.cert.name,this.cert.code);
        //   if(result.data.length>0)
        //   {
        //     this.$router.push({
        //       name: "MemberRlt",
        //       query: {
        //         name: this.cert.name,
        //         code: this.cert.code,
        //         inqType:"gr"
        //       }
        //     })
        //   }else{
        //     this.$message.error("您输入的信息不存在，谨防假冒。");
        //   }
        //   return
        // }
      let result =await certificateGR(this.cert.certtypename,this.cert.code,this.cert.name,this.cert.cardid);
      if(result.data.length==1)
      {
        this.cert = result.data[0];
        this.$router.push({
          name: "Show",
          query: {
            name: this.cert.name,
            code: this.cert.code,
            certtypename: this.cert.certtypename,
            inqType:this.isSelect
          }
        })
      }else if(result.data.length>1)
      {
        this.occupations = result.data || [];
        this.occupationFlag = true;
      }
    }
    }
  }
};
</script>
<style scoped >

.logo{
    text-align: center;
    position: relative;
    margin-top:8.867vw;
}
.logo img{
  width: 85.6vw;
}
.contentbox{
    height: 226.8vw;
    overflow: hidden;
    background-image: url(/static/img/img/shoujibgchauxn.png);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: left bottom;
}
.title{
   position: relative;
width: 93.333vw;
display:flex;
justify-content: space-between;
height: 3.733vw;
margin: 8vw auto 8vw;
}
.title a{
 
height: 3.733vw;
font-size: 3.733vw;
font-family: PingFang SC;
font-weight: 400;
color: #585B63;
line-height: 3.733vw;

}
.title a.light{
font-weight: bold;
color: #2F8EEC;
}
.title a.light::before{
  position: absolute;
  left:0;
  bottom:-2vw;
  content:'';
  width: 15.2vw;
height: 0.533vw;
background: #2F8EEC;
border-radius: 0.267vw;
}
.inqBox{
    position: relative;
    width: 93.333vw;
height: 106.667vw;
background: #FFFFFF;
box-shadow: 0px 1.6vw 6.8vw 0px rgba(68,98,207,0.19);
opacity: 0.9;
border-radius: 2.667vw;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
}

.inqBox h1{
  position: relative;
  margin-top:8vw;
  margin-bottom:2vw;
    text-align: center;
height: 4.8vw;
font-size: 4.8vw;
font-family: PingFang SC;
font-weight: bold;
color: #252626;
line-height: 4.8vw;
}
.inqBox h1::after{
  position: absolute;
  left:50%;
  transform: translateX(-50%);
  bottom:-4vw;
  content:'';
  width: 6.133vw;
height: 1.333vw;
background: #2F8EEC;
border-radius: 0.4vw;
}
.leftBox p{
  margin-top:15px ;
  text-align: left;
  color: #333333;
  font-size:16px;
}
.leftBox input {
    width: 64.533vw;
height: 11.067vw;
background: #F2F4F9;
border-radius: 0.667vw;
    font-size: 3.733vw;
font-family: PingFang SC;
font-weight: 400;
color: 333333;
line-height: 11.067vw;
}
.leftBox input::placeholder{
  color: #9BA1A8;
}
.leftBox .intype{
  padding-left: 12vw;
  margin-top:6vw ;
    width: 64.533vw;
height: 11.067vw;
background: #F2F4F9;
border-radius: 0.667vw;
    font-size: 3.733vw;
font-family: PingFang SC;
font-weight: 400;
color: #9BA1A8;
line-height: 11.067vw;
background-image: url(/static/img/img/da.png);
  background-repeat: no-repeat;
  background-size: 3.867vw 4.533vw;
border-radius: 0.667vw;
background-position: 3.067vw center;
}
.textbox{
  padding-left: 12vw;
  margin: 0 auto;
  position: relative;
    margin-top:6vw ;
   width: 64.533vw;
height: 11.067vw;
background: #F2F4F9;

}
.leftBox .shoujiios{
  background-image: url(/static/img/img/shoujiios.png);
  background-repeat: no-repeat;
  background-size: 4.267vw 4.133vw;
border-radius: 0.667vw;
background-position: 3.067vw center;
}
.leftBox .bianhaoda{
  background-image: url(/static/img/img/bianhaoda.png);
  background-repeat: no-repeat;
  background-size: 4.267vw 4.533vw;
border-radius: 0.667vw;
background-position: 3.067vw center;
}
.leftBox .da{
  background-image: url(/static/img/img/da.png);
  background-repeat: no-repeat;
  background-size: 3.867vw 4.533vw;
border-radius: 0.667vw;
background-position: 3.067vw center;
}
.intype::before,.textbox::before{
    content:'';
    position: absolute;
    top:3.467vw;
    left: 9.6vw;
    width: 0.267vw;
height: 4.133vw;
background: #E3E6EF;
z-index: 1;
   }

.leftBox button {
  margin-top:6.933vw ;
  width: 76.533vw;
height: 11.067vw;
background: #2F8EEC;
border-radius: 0.667vw;
line-height: 11.067vw;
font-size: 4.267vw;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}
.allbox{
  height: 369px;
}
.leftBox{
  height: 369px;
 
  display: inline-block;
}
.intype >>>.el-input__inner{
  background-color:transparent;
  border:none;
  height: 11.067vw;
    line-height: 11.067vw;
    padding:0px;
    font-size: 3.733vw;
    color:#9BA1A8;
}
.intype>>>.el-input__inner{
  color: #333333;
  /* font-size: 14px; */
}
.expBox{
  text-align: left;
  margin: auto;
  color: #7E8490;
    margin-top: 5.733vw;
    width: 93.333vw;
height: 49.333vw;
background: #FFFFFF;
box-shadow: 0px 1.6vw 6.8vw 0px rgba(68,98,207,0.19);
opacity: 0.6;
border-radius: 2.667vw;
overflow: hidden;
}
.expBox h2{
  margin-top: 7.467vw;
  margin-bottom:5.467vw ;
padding-left:11.6vw;
height: 3.733vw;
font-size: 3.733vw;
font-family: PingFang SC;
font-weight: 500;
color: #FF411C;
line-height: 3.733vw;
 background-image: url(/static/img/img/tishi.png);
  background-repeat: no-repeat;
  background-size: 3.333vw;
background-position: 5.467vw center;
}
.expBox p{
  padding-left:5.467vw;
  height: 3.2vw;
  font-size: 3.2vw;
  font-family: PingFang SC;
  font-weight: 500;
  color: #7E8490;
  line-height: 5vw;
}
.chgbox {
  display: flex;
  position: relative;
  top:30px;
  width: 350px;
  margin: auto;
}
.chgbox ul{
  display: flex;
}
.chgbox li{
  display: inline-block;
  width: 170px;
  text-align: center;
 
}
.active {
  color:#fff !important;
  background-color: #e6a23c !important;
}
.chgbtn{
  padding: 5px 15px;
  border-radius: 10px;
  width: 157px;
    background-color: #a9a9a961;
    padding: 6px 15px;
    border-radius: 20px;
    font-size: 16px;
    color: #d9d3d3;
}
  .recodenum{
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -7vw;
    height: 1.867vw;
    font-size: 1.867vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #AEB8C3;
    line-height: 1.867vw;
    text-align: center;
  }
</style>
